<template>
  <div class="login-desktop">
    <div>
      <img class="QRLogo" src="../assets/logo-white.png" alt="Logo" />
    </div>
    <div class="greeting-message">
      З ПОВЕРНЕННЯМ!
    </div>
    <div class="login-panel">
      <div class="mode-switch-panel">
        <div class="mode-switch-tab ">Адмін анель закладу</div>
        <div class="mode-switch-tab active-tab">Черга замовлень</div>
      </div>
      <div class="data-input-panel">
        <div class="login-type-switch">
          <div
            @click="setLoginType('personal')"
            :class="
              loginType == 'personal' ? 'login-type active-type' : 'login-type'
            "
          >
            Персональна
          </div>
          <div
            @click="setLoginType('common')"
            :class="
              loginType == 'common' ? 'login-type active-type' : 'login-type'
            "
          >
            Спільна
          </div>
        </div>
        <div>
          <div v-if="loginType == 'personal'" class="personal-login-form">
            <input
              class="login-date-input"
              placeholder="ID закладу"
              v-model="loginData.qId"
              type="text"
            />
            <input
              class="login-date-input"
              placeholder="Ваш пін-код "
              v-model="loginData.pin"
              type="text"
            />
            <button @click="loginAsWaiter()" class="submit-login-btn">
              До замовлень ->
            </button>
          </div>
          <div v-else class="common-login-form">
            <input
              class="login-date-input"
              placeholder="ID закладу"
              v-model="loginData.qId"
              type="text"
            /><button @click="loginIntoSharedQueue()" class="submit-login-btn">
              До замовлень ->
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="support-link"><a href="">Support</a></div>
  </div>
</template>
<script>
import AuthAPI from "@/api/auth";
import SharedQueueService from "@/services/shared";

export default {
  data() {
    return {
      loginType: "personal",
      loginData: { qId: "", pin: "" },
    };
  },
  methods: {
    setLoginType(type) {
      this.loginType = type;
    },
    loginAsWaiter() {
      AuthAPI.loginAsWaiter(this.loginData.qId, this.loginData.pin)
        .then((data) => {
          SharedQueueService.clearStamp();
          this.$store.dispatch("init").then((ok) => {
            this.$router.push("/orders");
          });
        })
        .catch((error) => {
          this.error = error;

          this.loginData.pin = "";
        });
    },
    loginIntoSharedQueue() {
      AuthAPI.loginShared(this.loginData.qId)
        .then((data) => {
          SharedQueueService.saveSharedStamp(data.sid);
          this.$router.push("/preorder");
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  mounted() {
    let href = 'https://qrwaiter.com.ua/login'
    if (this.$route.params.qid) {
      href += `?qid=${this.$route.params.qid}`;
    }
    
    window.location.href = href;
  }
};
</script>
<style scoped>
.login-desktop {
  width: 100%;
  height: 100vh;
  background: #1d1d1b;
}
.QRLogo {
  width: 2.083vw;
  height: 2.083vw;
  margin: 1.597vw 3.472vw 0;
}
.greeting-message {
  float: right;
  font-weight: 500;
  font-size: 5vw;
  line-height: 5.764vw;
  color: #464646;
  margin: 17.444444444444443vh 7.083vw 6.222222222222222vh;
}
.login-panel {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.mode-switch-tab {
  width: 24.722vw;
  height: 7.222222222222222vh;
  font-weight: 500;
  font-size: 2.014vw;
  line-height: 2.292vw;
  display: flex;
  align-items: center;
  padding-left: 1.944vw;
  color: #908f8d;
  cursor: pointer;
}
.active-tab {
  color: #ededed;
  background: #464646;
}
.data-input-panel {
  width: 65.139vw;
  height: 38vh;
  background: #464646;
  padding: 3.111111111111111vh 7.569vw 0;
}
.login-type-switch {
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
}
.login-type {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12.292vw;
  height: 5.555555555555555vh;
  font-weight: 500;
  font-size: 1.528vw;
  line-height: 1.736vw;

  color: #908f8d;
}
.active-type {
  background: #000000;
  color: #ededed;
}
.personal-login-form,
.common-login-form {
  display: flex;
  flex-direction: column;
  padding-top: 2.7777777777777777vh;
}
.login-date-input {
  width: 31.042vw;
  height: 5.555555555555555vh;
  border: none;
  background: #000000;
  padding: 1.3333333333333333vh 1.215vw;
  margin-bottom: 2.7777777777777777vh;
  font-size: 1.528vw;
  line-height: 1.736vw;
  color: #908f8d;
}
.submit-login-btn {
  width: 31.042vw;
  height: 5.555555555555555vh;
  background: #129b81;
  border: none;
  color: #1d1d1b;
  font-size: 1.528vw;
  line-height: 1.736vw;
  margin-top: 5vh;
}
.support-link {
  margin: 14.25vh 3.472vw 0;
}
.support-link a {
  font-weight: 500;
  font-size: 2.014vw;
  line-height: 2.292vw;
  color: #cbd9e6;
  text-decoration: none;
}
</style>
